import { isInsideMobileApp } from '../../util/billing.ts';
import { isContainingAppAtLeast } from '../../util/containing_app.ts';

// The first store app versions that get the Learn tab: 24.0 is the first Android version that grants
// the microphone and the first iOS version with the microphone usage description, and App Review has
// to reach the tab without an internal account (issue #3526)
export const LearnTabMinimumAppVersion = '24.0';

// What the Learn tab is for the current client (issue #3821). Every client gets the tab.
export enum LearnTabAccess {
  Open = 'open', // the hub and every /learn route
  UpdateApp = 'update-app', // an "update the app" screen in place of every /learn route
}

// Everyone in a browser and everyone inside a store app of at least LearnTabMinimumAppVersion gets
// Learn, internal or not. A store app older than that cannot grant the microphone, and 24.0 is in
// both stores, so it gets the update screen instead. Only a store app ever gets that screen, never a
// browser. Old apps are recognized through billing.ts's deprecated pre-24.0 fallbacks; once those are
// removed an old app looks like a browser and gets Learn as it is.
export function getLearnTabAccess(): LearnTabAccess {
  if (!isInsideMobileApp() || isContainingAppAtLeast(LearnTabMinimumAppVersion)) {
    return LearnTabAccess.Open;
  }
  // TODO(remove after 2027-10-13): store apps older than 24.0 (iOS 4.x, Google Play 23 and earlier)
  // get the update screen, a year after Android 24.0 reached Google Play; delete with the pre-24.0
  // fallbacks in billing.ts isInsideAppleAppStoreApp and isInsideGooglePlayApp, along with LearnTabAccess, its branch in learn_page.tsx,
  // learn_update_app_screen.tsx (OldIOSAppStoreUrl, getUpdateAppUrl), the UpdateApp cases in
  // learn_visibility.test.ts and the UpdateApp frame in learn_hub.stories.tsx
  return LearnTabAccess.UpdateApp;
}
